import React, { useState, useEffect } from "react";
import "./styles/Background.css";

const setRandomAnimationDelay = () => {
    document.querySelectorAll(".background-object").forEach((element) => {
        const randomDelay = Math.random() * -11; // Random delay between -4s and 0s
        element.style.animationDelay = `${randomDelay}s`;
    });
};

const sparkleSettings = [
    { top: "30vh", left: "5vw", rotate: "0deg", width: "2vw" },
    { top: "30vh", left: "55vw", rotate: "0deg", width: "3vw" },
    { top: "55vh", left: "25vw", rotate: "0deg", width: "2vw" },
    { top: "55vh", left: "80vw", rotate: "0deg", width: "6vw" },
    { top: "80vh", left: "5vw", rotate: "0deg", width: "5vw" },
    { top: "85vh", left: "65vw", rotate: "0deg", width: "6vw" }
];

const bunnySettings = [
    { top: "15vh", left: "20vw", rotate: "0deg", width: "10vw" },
    { top: "30vh", left: "90vw", rotate: "0deg", width: "8vw" },
    { top: "55vh", left: "5vw", rotate: "0deg", width: "7vw" },
    { top: "55vh", left: "45vw", rotate: "0deg", width: "14vw" },
    { top: "80vh", left: "25vw", rotate: "0deg", width: "10vw" },
    { top: "90vh", left: "90vw", rotate: "0deg", width: "7vw" }
];

const Background = () => {
    const [floating, setFloating] = useState(false);
    const [showMenu, setShowMenu] = useState(false);
    const [fadeIn, setFadeIn] = useState(false);

    useEffect(() => {
        setTimeout(() => setFadeIn(true), 1000); // Trigger fade-in after shrink animation
        setFloating(true); // Start floating effect
        setRandomAnimationDelay();

        // Function to check screen width and update showMenu
        const handleResize = () => {
            setShowMenu(window.innerWidth > 1000);
        };

        // Attach resize event listener
        window.addEventListener("resize", handleResize);
        handleResize();

        // Cleanup event listener on component unmount
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <>
            <div className="background">
                {sparkleSettings.map((sparkle, index) => (
                    <div
                        key={index}
                        className="sparkle-container"
                        style={{
                            transform: `rotate(${sparkle.rotate})`
                        }}
                    >
                        <img
                            className="background-object sparkle"
                            src="/images/Sparkles.png"
                            alt="Background Sparkles"
                            style={{
                                position: "absolute",
                                top: sparkle.top,
                                left: sparkle.left,
                                width: sparkle.width
                            }}
                        />
                    </div>
                ))}
                {bunnySettings.map((bunny, index) => (
                    <div
                        key={index}
                        className="sparkle-container"
                        style={{
                            transform: `rotate(${bunny.rotate})`
                        }}
                    >
                        <img
                            className="background-object bunny"
                            src="/images/BunnyOutline.png"
                            alt="Background Bunnies"
                            style={{
                                position: "absolute",
                                top: bunny.top,
                                left: bunny.left,
                                width: bunny.width
                            }}
                        />
                    </div>
                ))}
            </div>
        </>
    )
}

export default Background